// src/api/contentful.js
export async function getPortfolio() {
  const accessToken = process.env.REACT_APP_ACCESS_TOKEN;
  const spaceId = "124h1xezlabw";
  const environment = "master";
  const contentType = "portfolio";

  const url = `https://cdn.contentful.com/spaces/${spaceId}/environments/${environment}/entries?access_token=${accessToken}&content_type=${contentType}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();

    // Return both entries and assets so you can map thumbnails later
    return {
      items: data.items || [],
      includes: data.includes || { Asset: [] },
    };
  } catch (error) {
    console.error("Failed to fetch portfolio:", error);
    return { items: [], includes: { Asset: [] } };
  }
}
